import { Button } from "@/modern/components/ui/button-shadcn";
import { NotebookPen, Plus } from "lucide-react";
import { useEntityNotesContext } from "../context/EntityNotesContext";

export const EmptyNotesState = () => {
  const { handleOpenEditor } = useEntityNotesContext();
  return (
    <div className="min-h-[12rem] h-full flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 p-4 text-center shadow-sm m-4">
      <div className="mx-auto flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <NotebookPen className="size-5" />
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-semibold text-foreground">Rich-Text Notes</h3>
        <p className="text-xs text-muted-foreground">Add detailed, formatted notes for the team.</p>
      </div>
      <Button className="inline-flex items-center gap-2" onClick={() => handleOpenEditor(undefined, true)}>
        <Plus className="size-4" />
        New note
      </Button>
    </div>)
};
